import React from 'react';
import DynamicWebServiceDrivenForm from "../../platform/webform/DynamicWebServiceDrivenForm";
import {Card} from "../../components/Card";
import {useNavigate, useParams} from "react-router";

export function EditStandardPage(props: {}) {
    const {id, entryIdx} = useParams();
    var navigate = useNavigate();

    return <>
        <Card header={"Edytuj typoszereg"}>
            <p>Uwaga - zmiana klucza wg którego przeszukiwany jest typoszereg (identyfikatora wiersza), przy zapisie może spowodować powstanie nowego rekordu w typoszeregu.
            Po takiej operacji zalecany jest powrót do strony typoszeregów i usunięcie wiersza o pierwotnym identyfikatorze, jeżeli nie jest już potrzebny.</p>
            <DynamicWebServiceDrivenForm dslUrl={`/api/standard-editor/${id}/${entryIdx}`}
                                         submissionUrl={`/api/standard-editor/${id}/${entryIdx}/submit`}
                                         submitLabel="Zapisz"
                                         successHandler={() => {
                                             alert('Standard został zaktualizowany');
                                             navigate(`/standard-listing#listing-${id}`);
                                         }}/>
        </Card>
    </>
}
